// marketingMeta.js — shared marketing metadata for the public homepage nav.
//
// The public serviceCatalog (../lib/serviceCatalog) carries copy + price + icon
// but not the marketing slug or capability cluster. Those live on the backend
// product catalog (services/productCatalog.js) and drive the SSR /products
// pages. We mirror the canonical key → { slug, cluster } map here so the
// Apple-style mega-nav can group services by cluster and deep-link each one to
// its /products/<slug> page. Keep this in sync with the backend catalog.

export const PRODUCT_META = {
  answers:           { slug: 'ai-support-chatbot',            cluster: 'Answer' },
  sync:              { slug: 'knowledge-sync',                cluster: 'Answer' },
  rag:               { slug: 'custom-rag-api',                cluster: 'Answer' },
  intake:            { slug: 'multi-specialty-intake',        cluster: 'Answer' },
  voice:             { slug: 'voice-ai-receptionist',         cluster: 'Answer' },
  inbox:             { slug: 'team-inbox',                    cluster: 'Answer' },
  orchestration:     { slug: 'agentic-workflows',             cluster: 'Build' },
  middleware:        { slug: 'integration-adapters',          cluster: 'Build' },
  agent:             { slug: 'tool-using-agent-mcp',          cluster: 'Build' },
  campaigns:         { slug: 'whatsapp-campaigns',            cluster: 'Sell' },
  commerce:          { slug: 'whatsapp-commerce',             cluster: 'Sell' },
  'marketing-intel': { slug: 'marketing-intelligence-brain',  cluster: 'Grow' },
  growth:            { slug: 'growth-lab',                    cluster: 'Grow' },
  seo:               { slug: 'seo-intelligence',              cluster: 'Grow' },
  reseller:          { slug: 'white-label-reseller',          cluster: 'Resell' },
}

// Capability lanes, in display order, with a one-line tagline for the mega-nav.
export const CLUSTERS = [
  { name: 'Answer', tagline: 'Support & knowledge, grounded in your content' },
  { name: 'Build',  tagline: 'APIs, automations & agents over your data' },
  { name: 'Sell',   tagline: 'Turn conversations into orders' },
  { name: 'Grow',   tagline: 'Marketing intelligence, evidence-first' },
  { name: 'Resell', tagline: 'Run the whole platform as your own' },
]

export const slugFor = (key) => PRODUCT_META[key]?.slug || key
export const clusterFor = (key) => PRODUCT_META[key]?.cluster || 'Build'
export const productHref = (key) => `/products/${slugFor(key)}`

// Price display: $0 reads as "Free" everywhere the catalog price is shown.
export const fmtPrice = (p) => (Number(p) === 0 ? 'Free' : `$${p}`)

// Group an enriched catalog (services carrying a live `price`) into the five
// clusters, preserving CLUSTERS order and dropping empty lanes. HEADLESS-aware:
// a service row's OWN `cluster`/`slug` (returned by /api/v1/site/catalog) wins, so
// agent/admin-registered products land in the right lane and link to the right
// page; the static PRODUCT_META map is only a fallback for rows that lack them.
export function groupByCluster(services) {
  return CLUSTERS.map((c) => ({
    ...c,
    items: services
      .filter((s) => (s.cluster || clusterFor(s.key)) === c.name)
      .map((s) => ({ ...s, slug: s.slug || slugFor(s.key) })),
  })).filter((g) => g.items.length > 0)
}
